import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "tw-flex tw-items-end tw-gap-4 tw-rounded-tl-2xl tw-border-0 tw-border-b tw-border-solid tw-border-sf-slate-lighter-1 tw-bg-sf-slate-subtle-1 tw-pl-[25px] tw-pt-[11px] tw-pr-6 tw-drop-shadow-[0px_1px_0.5px_rgba(0,0,0,0.05)]"
};
const _hoisted_2 = [
    "href",
    "aria-current"
];
const _hoisted_3 = {
    key: 0,
    class: "tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-0.5 tw-bg-sf-primary"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'user-management-tabs',
    props: {
        tabs: {}
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab)=>{
                    return _openBlock(), _createElementBlock("a", {
                        key: tab.key,
                        href: tab.path,
                        class: _normalizeClass([
                            tab.active ? 'active tw-font-medium tw-text-sf-slate-dark-2' : 'tw-text-sf-slate',
                            "tw-relative tw-flex tw-h-12 tw-items-center tw-px-2 tw-font-sans tw-text-base tw-leading-[1.4] tw-no-underline"
                        ]),
                        "aria-current": tab.active ? 'page' : undefined
                    }, [
                        _createTextVNode(_toDisplayString(tab.label) + " ", 1),
                        tab.active ? (_openBlock(), _createElementBlock("span", _hoisted_3)) : _createCommentVNode("", true)
                    ], 10, _hoisted_2);
                }), 128))
            ]);
        };
    }
});
